import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import ApiMe from "@/api/ApiMe";

import { MemoruHomeMeResponse } from "@API/src/component/memoruHome/me/types";
import { PutMeRequest } from "@/model/request/me";

export interface MeState {
  me: MemoruHomeMeResponse | null;
}

@Module({ dynamic: true, store, name: "me", namespaced: true })
class MeModule extends VuexModule implements MeState {
  public me: MemoruHomeMeResponse | null = null;

  @Action({ rawError: true })
  public async fetchMe() {
    const response: MemoruHomeMeResponse = await ApiMe.fetchMe();
    this.setMe(response);
    return response;
  }

  @Mutation
  public setMe(me: MemoruHomeMeResponse) {
    this.me = me;
  }

  @Action({ rawError: true })
  public async putMe(request: PutMeRequest) {
    const response: MemoruHomeMeResponse = await ApiMe.putMe(request);
    this.setMe(response);
    return true;
  }
}

export const meModule = getModule(MeModule);
